import { IHttpConnectionOptions, IHubProtocol } from "@microsoft/signalr";
import { SignalrHub } from "./SignalrHub";

const hubs: SignalrHub[] = [];

export const findHub = ({ hubName, url }: { hubName: string; url: string }) =>
  hubs.find((h) => h.hubName === hubName && h.url === url);

export const findHubByName = (hubName: string) =>
  hubs.find((h) => h.hubName === hubName);

export const removeHubByName = (hubName: string) => {
  const index = hubs.findIndex((h) => h.hubName === hubName);
  if (index > -1) {
    hubs.splice(index, 1);
  }
};

export const createHub = (
  hubName: string,
  url: string,
  options?: IHttpConnectionOptions,
  automaticReconnect?: boolean | number[],
  withHubProtocol?: IHubProtocol
) => {
  const hub = new SignalrHub(
    hubName,
    url,
    options,
    automaticReconnect,
    withHubProtocol
  );
  hubs.push(hub);
  return hub;
};
